var map = {
	"./scenario_01_barcelona_morning/customers/julian_brands.json": 974,
	"./scenario_01_barcelona_morning/customers/justin_barman.json": 535,
	"./scenario_01_barcelona_morning/customers/maria_santos.json": 569,
	"./scenario_01_barcelona_morning/customers/neila_chen.json": 718,
	"./scenario_01_barcelona_morning/customers/sarah_chen.json": 398,
	"./scenario_02_north_europe_storm/customers/anna_schmidt.json": 882,
	"./scenario_02_north_europe_storm/customers/elena_volkova.json": 181,
	"./scenario_02_north_europe_storm/customers/henrik_mueller.json": 877,
	"./scenario_02_north_europe_storm/customers/lisa_karlsson.json": 688,
	"./scenario_02_north_europe_storm/customers/marcus_johansson.json": 736,
	"./scenario_02_north_europe_storm/customers/peter_van_der_berg.json": 140,
	"./scenario_02_north_europe_storm/customers/sophie_dupont.json": 704,
	"./scenario_02_north_europe_storm/customers/thomas_andersen.json": 52,
	"./scenario_03_france_atc_strike/customers/alexandra_rousseau.json": 857,
	"./scenario_03_france_atc_strike/customers/anna_kowalski.json": 735,
	"./scenario_03_france_atc_strike/customers/david_kim.json": 753,
	"./scenario_03_france_atc_strike/customers/emma_laurent.json": 123,
	"./scenario_03_france_atc_strike/customers/francois_dubois.json": 597,
	"./scenario_03_france_atc_strike/customers/henrik_larsson.json": 721,
	"./scenario_03_france_atc_strike/customers/isabella_romano.json": 803,
	"./scenario_03_france_atc_strike/customers/james_patterson.json": 728,
	"./scenario_03_france_atc_strike/customers/maria_garcia.json": 287,
	"./scenario_03_france_atc_strike/customers/michael_schmidt.json": 985,
	"./scenario_03_france_atc_strike/customers/pierre_moreau.json": 678,
	"./scenario_03_france_atc_strike/customers/sophie_martin.json": 229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 517;